import React from "react"
import successCircle from "assets/images/LockLocked_Circle_Blue_check.svg"
import { Spinner } from "@walmart-web/livingdesign-components"
import "./index.scss"
import { useIntl } from "react-intl"
import { logout } from "helpers/authUtils"
import { redirect } from "navigation/redirect"
import { PHRONESIS_LOGIN, ROOT_CONTEXT } from "constants/paths"

const ChangePasswordSuccess: React.FC = () => {
	const intl = useIntl()

	React.useEffect(() => {
		setTimeout(() => {
			const logoutAndRedirect = async () => {
				await logout(true)
				redirect(`${ROOT_CONTEXT}${PHRONESIS_LOGIN}`)
			}
			logoutAndRedirect()
		}, 8000)
	}, [])

	return (
		<div className="change-password-success-container">
			<img src={successCircle} aria-hidden alt={""} />
			<div className="change-password-success-title">
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.success.title",
				})}
			</div>
			<div className="change-password-success-content">
				{intl.formatMessage({
					id: "phronesis.configuration.change-password.success.description",
				})}
			</div>
			<Spinner size={"large"} />
		</div>
	)
}

export default ChangePasswordSuccess
